export const ProgressSteps = ({ items, current }) => {
  return (
    <div className="progress-steps" data-testid="progress-steps">
      {items.map((item, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <div
            key={item}
            className={`ps-item ${done ? "done" : ""} ${active ? "current" : ""}`}
            data-testid={`progress-step-${index}`}
          >
            <div className={`ps-dot ${done ? "done" : active ? "current" : "pending"}`}>
              {done ? "✓" : index + 1}
            </div>
            <div className={`ps-label ${active ? "active" : ""}`}>{item}</div>
          </div>
        );
      })}
    </div>
  );
};
